import { apiFetch } from '../utils/apiFetch';
import { API_CONFIG } from '../constants';
import { PatientResponse, CheckVitalsResponse } from '../dtos/patient';

export const fetchPatientById = async (patientId: number): Promise<PatientResponse> => {
    const response = await apiFetch({
        url: API_CONFIG.ENDPOINTS.PATIENT(patientId),
        method: 'GET',
        params: {
            patient_id: patientId,
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch patient: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data[0] : data;
};

export const checkVitals = async (sessionId: number): Promise<CheckVitalsResponse> => {
    const response = await apiFetch({
        url: API_CONFIG.ENDPOINTS.CHECK_VITALS,
        method: 'POST',
        body: { sessionId },
    });

    if (!response.ok) {
        throw new Error(`Failed to check vitals: ${response.status}`);
    }

    return response.json();
};
